/* Flaming Phoenix guide pages (fpgx): contents list, FAQ folding, reading time, sticky bar and
   one-tap add to bag. Content stays in the HTML; this only arranges it. Built 19 Oct 2026. */
(function () {
  var root = document.querySelector('[data-fpgx-root]'); if (!root) return;
  var doc = document, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function track(type, place, pack) {
    var d = { place: place || '', pack: pack || '', page: location.pathname };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('fpg_' + type, d); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'fpg_' + type, fpg_place: d.place, fpg_pack: d.pack }); } catch (e) {}
  }
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function lvl(el) { return +el.tagName.charAt(1) || 9; }

  /* FAQ: fold the page's own questions into a tidy list */
  var faqWords = (root.getAttribute('data-faq') || 'question,faq').split(','), faqHeads = [];
  var faqRe = new RegExp('(' + faqWords.map(function (w) { return w.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'i');
  doc.querySelectorAll('.fpgx-text .fpgx-prose').forEach(function (box) {
    var hs = box.querySelectorAll('h2,h3,h4,h5');
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i]; if (!faqRe.test(txt(h)) || txt(h).length > 90) continue;
      var L = lvl(h), nodes = [], n = h.nextElementSibling;
      while (n && !(/^H[1-6]$/.test(n.tagName) && lvl(n) <= L)) {
        /* stop before a Sources line or a Related guides heading, so they stay visible after the FAQ */
        if (n.tagName === 'P' && /^\s*(sources?|further reading)\s*[:.]/i.test(txt(n))) break;
        if (/^H[1-6]$/.test(n.tagName) && /^\s*(related guides|related reading|sources|further reading)\b/i.test(txt(n))) break;
        nodes.push(n); n = n.nextElementSibling;
      }
      var items = [], cur = null;
      var subHeads = nodes.some(function (x) { return /^H[1-6]$/.test(x.tagName); });
      nodes.forEach(function (x) {
        var t = txt(x);
        if (subHeads) {
          if (/^H[1-6]$/.test(x.tagName)) { cur = { q: x, a: [] }; items.push(cur); } else if (cur) cur.a.push(x); else cur = null;
          return;
        }
        if (x.tagName !== 'P') { if (cur) cur.a.push(x); return; }
        var first = x.firstElementChild, strongOnly = first && /^(STRONG|B)$/.test(first.tagName) && txt(first) === t;
        if ((strongOnly || (/\?$/.test(t) && t.length < 200)) && t.length < 220) { cur = { q: x.innerHTML, a: [], qel: x }; items.push(cur); return; }
        if (first && /^(STRONG|B)$/.test(first.tagName) && x.firstChild === first && /\?\s*$/.test(txt(first))) {
          var q = first.innerHTML; first.remove(); cur = { q: q, a: [x] }; items.push(cur); return;
        }
        var m = t.match(/^([^?]{8,160}\?)\s+(.+)$/);
        if (m && (!cur || cur.split || cur.a.length)) { cur = { q: m[1], a: [], split: x }; items.push(cur); return; }
        if (cur) cur.a.push(x);
      });
      items = items.filter(function (it) { return it.a.length || it.split; });
      if (items.length < 2) continue;
      faqHeads.push(h);
      var wrap = doc.createElement('div'); wrap.className = 'fpg-faq';
      h.parentNode.insertBefore(wrap, nodes[0] || h.nextSibling);
      items.forEach(function (it, k) {
        var d = doc.createElement('details'); if (k === 0) d.open = true;
        var s = doc.createElement('summary');
        if (it.q.nodeType === 1) { s.appendChild(it.q); } else { var sp = doc.createElement('span'); sp.className = 'fpgx-q'; sp.innerHTML = it.q; s.appendChild(sp); }
        var a = doc.createElement('div'); a.className = 'fpg-faq__a';
        if (it.split) { var p = doc.createElement('p'); var t2 = it.split.innerHTML, qi = t2.indexOf('?'); p.innerHTML = t2.slice(qi + 1).replace(/^\s+/, ''); a.appendChild(p); it.split.remove(); }
        if (it.qel) it.qel.remove();
        it.a.forEach(function (x) { a.appendChild(x); });
        d.appendChild(s); d.appendChild(a); wrap.appendChild(d);
      });
      nodes.forEach(function (x) { if (x.parentNode === box && !wrap.contains(x) && !txt(x)) x.remove(); });
    }
  });

  /* Contents list from the chapter headings (plus the FAQ heading, whatever its level) */
  var h1el = doc.querySelector('main h1'), h1txt = h1el ? txt(h1el).toLowerCase() : '';
  var heads = [], used = {}, skipRe = /^(related guides?|buy phoenix bars|guides associés|passende ratgeber)$/i;
  doc.querySelectorAll('.fpgx-text').forEach(function (sec) {
    var ch = sec.getAttribute('data-ch') || 'h3', n = +ch.charAt(1);
    sec.querySelectorAll('.fpgx-hb, .fpgx-prose h2, .fpgx-prose h3, .fpgx-prose h4').forEach(function (h) {
      if (h.closest('.fpg-faq') || !txt(h) || skipRe.test(txt(h)) || txt(h).toLowerCase() === h1txt) return;
      if (h.classList.contains('fpgx-hb') || lvl(h) <= n || faqHeads.indexOf(h) > -1) heads.push(h);
    });
  });
  function slug(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section'; }
  heads.forEach(function (h) {
    if (!h.id) { var b = slug(txt(h)), id = b, k = 2; while (used[id] || doc.getElementById(id)) id = b + '-' + k++; h.id = id; }
    used[h.id] = 1;
  });
  var lists = doc.querySelectorAll('[data-fpgx-toc]');
  if (heads.length >= 2) {
    lists.forEach(function (ol) {
      heads.forEach(function (h) { var li = doc.createElement('li'), a = doc.createElement('a'); a.href = '#' + h.id; a.textContent = txt(h); li.appendChild(a); ol.appendChild(li); });
    });
  } else {
    doc.querySelectorAll('.fpgx-mtoc, .fpgx-rail .fpg-toc').forEach(function (el) { el.hidden = true; });
  }
  var mt = doc.querySelector('.fpgx-mtoc');
  if (mt) mt.addEventListener('click', function (e) { if (e.target.closest('a')) mt.open = false; });
  var railLinks = doc.querySelectorAll('.fpgx-rail .fpg-toc a');
  function spy() {
    var cur = null;
    heads.forEach(function (h) { if (h.getBoundingClientRect().top < window.innerHeight * 0.3) cur = h.id; });
    railLinks.forEach(function (a) { if (a.getAttribute('href') === '#' + cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
  }
  if (railLinks.length) { window.addEventListener('scroll', function () { requestAnimationFrame(spy); }, { passive: true }); spy(); }

  /* Reading time and progress */
  var words = 0; doc.querySelectorAll('.fpgx-text').forEach(function (s) { words += txt(s).split(' ').length; });
  var mins = Math.max(1, Math.round(words / 230)), rt = doc.querySelector('[data-fpgx-mins]');
  if (rt) rt.textContent = mins + ' ' + (root.getAttribute('data-read') || 'minute read');
  var pb = doc.querySelector('.fpgx-herowrap .fpg-progress i'), main = doc.querySelector('main') || doc.body, ticking = false;
  function prog() {
    var r = main.getBoundingClientRect(), total = r.height - window.innerHeight;
    var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
    pb.style.transform = 'scaleX(' + p.toFixed(3) + ')';
  }
  if (pb) { window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { prog(); ticking = false; }); } }, { passive: true }); prog(); }

  /* Sticky bar: after the title band, hidden while a buy card or the footer is on screen */
  var bar = root.querySelector('[data-fpg-bar]');
  if (bar && hasIO) {
    var past = false, seen = new Set(), off = false;
    try { off = sessionStorage.getItem('fpg-bar-off') === '1'; } catch (e) {}
    var trig = doc.querySelector('.fpgx-hero');
    function upd() {
      var on = past && seen.size === 0 && !off;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { if (on) b.removeAttribute('tabindex'); else b.setAttribute('tabindex', '-1'); });
      doc.documentElement.classList.toggle('fpg-bar-on', on);
    }
    if (trig) new IntersectionObserver(function (es) { past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; upd(); }).observe(trig);
    var hide = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); }); upd(); });
    doc.querySelectorAll('.fpgx-promo [data-fpg-buy], .fpgx-panel [data-fpg-buy], .gec__card').forEach(function (el) { hide.observe(el); });
    var ft = doc.querySelector('.footer') || doc.querySelector('footer'); if (ft) hide.observe(ft);
    var x = bar.querySelector('[data-fpg-bar-x]');
    if (x) x.addEventListener('click', function () { off = true; try { sessionStorage.setItem('fpg-bar-off', '1'); } catch (e) {} track('bar_hide', 'bar', ''); upd(); });
  }

  /* Pack choice */
  doc.querySelectorAll('.fpgx [data-fpg-packs]').forEach(function (g) {
    var btn = g.closest('[data-fpg-buy]').querySelector('[data-fpg-add]');
    g.addEventListener('change', function (e) {
      var i = e.target; if (!i.matches('input[type=radio]')) return;
      btn.setAttribute('data-fpg-add', i.value); btn.setAttribute('data-fpg-pack', i.getAttribute('data-pack')); btn.textContent = i.getAttribute('data-label');
      g.querySelectorAll('.fpg-pack').forEach(function (l) { l.classList.toggle('is-on', l.contains(i)); });
    });
  });

  /* One-tap add to bag, then Dawn's cart pop-up */
  function add(b) {
    var id = +b.getAttribute('data-fpg-add'); if (!id) return;
    var box = b.closest('[data-fpg-buy]') || b.parentNode, err = box && box.querySelector('.fpg-err');
    var was = b.textContent; b.disabled = true; b.textContent = root.getAttribute('data-adding') || 'Adding…'; if (err) err.hidden = true;
    track('add_to_cart', b.getAttribute('data-fpg-place'), b.getAttribute('data-fpg-pack'));
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      b.disabled = false; b.textContent = was;
      if (!j.items) { if (err) { err.textContent = j.description || root.getAttribute('data-err'); err.hidden = false; } return; }
      var cn = doc.querySelector('cart-notification');
      if (cn && j.sections && j.items.length) { try { cn.renderContents({ key: j.items[0].key, sections: j.sections }); return; } catch (e) {} }
      location.href = '/cart';
    }).catch(function () { location.href = '/cart'; });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.fpgx [data-fpg-add]'); if (b) { e.preventDefault(); add(b); return; }
    var a = e.target.closest && e.target.closest('.fpgx a[data-fpg-track]'); if (a) track('click', a.getAttribute('data-fpg-track'), '');
  });
})();
